import React from 'react';

/**
 * Wraps a filter control (select, input, checkbox label) with a clear × button.
 * Show the clear button only when the filter has a non-empty value.
 *
 * Usage:
 *   <FilterBar onResetAll={resetFn} hasActiveFilters={bool}>
 *     <FilterBar.Item value={status} onClear={() => setStatus('')}>
 *       <select .../>
 *     </FilterBar.Item>
 *     ...
 *   </FilterBar>
 */

function Item({ value, onClear, children }) {
  const active = value !== '' && value !== false && value != null;
  return (
    <div className="relative flex items-center">
      {children}
      {active && (
        <button
          onClick={onClear}
          title="Clear filter"
          className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-gray-400 hover:bg-red-500 text-white flex items-center justify-center text-[10px] font-bold leading-none transition-colors z-10"
        >
          ×
        </button>
      )}
    </div>
  );
}

export default function FilterBar({ children, onResetAll, hasActiveFilters }) {
  return (
    <div className="card p-4 flex flex-wrap gap-3 items-center">
      {children}
      {hasActiveFilters && (
        <button
          onClick={onResetAll}
          className="ml-auto flex items-center gap-1.5 text-sm text-red-500 hover:text-red-700 font-medium px-3 py-2 rounded-lg hover:bg-red-50 transition-colors border border-red-200 hover:border-red-300"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
          </svg>
          Reset All
        </button>
      )}
    </div>
  );
}

FilterBar.Item = Item;
